import { EmptyState } from '@bennows/boows-react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { PageHeader } from '../../components/PageHeader';

/** A path the console does not know, or one the operator's role may not open (the server refuses it as well). */
export function NotFoundPage({ forbidden = false }: { readonly forbidden?: boolean }) {
  const { t } = useTranslation();
  const key = forbidden ? 'forbidden' : 'notFound';
  return (
    <div className="ui-stack">
      <PageHeader title={t(`${key}.title`)} />
      <EmptyState title={t(`${key}.text`)} action={<Link to="/">{t('notFound.home')}</Link>} />
    </div>
  );
}
